import { render, staticRenderFns } from "./ChangeBorrowerId.vue?vue&type=template&id=52fd7eee&scoped=true&"
import script from "./ChangeBorrowerId.vue?vue&type=script&lang=js&"
export * from "./ChangeBorrowerId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fd7eee",
  null
  
)

export default component.exports